<!-- ── CURRENCY & GROWTH ── -->
<app-ip-shell [activeStep]="3">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Step 03 &middot; Currency &amp; Growth</div>
      <h1 class="ip-form-head__title" id="step3-title">
        {{ foreignbuyer === '1' ? 'Home currency and growth assumptions' : 'Growth assumptions' }}
      </h1>
      <p class="ip-form-head__subtitle" id="step3-subtitle">
        Set your home currency and expected growth rates.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- Home Currency (foreign buyers only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1'" id="currency-block">
        <div class="ip-field__head">
          <label class="ip-field__label">Home currency</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Live FX lookup</span>
        </div>
        <div class="s3-currency-wrap" id="currencySelectWrap">
          <button
            type="button"
            class="s3-currency-btn"
            (click)="currencyDropdownOpen=!currencyDropdownOpen"
            [class.open]="currencyDropdownOpen">
            <span class="s3-currency-val" [class.placeholder]="!homecurrencyText">
              {{ homecurrencyText ? getCurrencyLabel(homecurrencyText) : 'Select currency' }}
            </span>
            <svg class="s3-currency-chevron" [class.rotated]="currencyDropdownOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
          </button>
          <div class="s3-dropdown" *ngIf="currencyDropdownOpen">
            <div class="s3-dropdown__search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              <input
                type="text"
                class="s3-dropdown__input"
                placeholder="Search currency..."
                [(ngModel)]="currencySearch"
                autocomplete="off"
                (click)="$event.stopPropagation()">
            </div>
            <div class="s3-dropdown__list">
              <div
                *ngFor="let c of getFilteredCurrencies()"
                class="s3-dropdown__item"
                [class.selected]="homecurrencyText === c.code"
                (click)="selectCurrency(c.code)">
                <span class="s3-dropdown__item-name">{{ c.name }}</span>
                <span class="s3-dropdown__item-code">{{ c.code }}</span>
              </div>
              <div class="s3-dropdown__empty" *ngIf="getFilteredCurrencies().length === 0">No currencies found</div>
            </div>
          </div>
        </div>
      </div>

      <!-- FX Rate (foreign buyers, read-only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1' && homecurrencyText && homecurrency">
        <div class="ip-field__head">
          <label class="ip-field__label">FX rate (1 GBP)</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Live rate</span>
        </div>
        <div class="ip-input">
          <input type="text" class="ip-input__field" [value]="homecurrency || '—'" readonly>
          <span class="ip-input__suffix">{{ homecurrencyText }}</span>
        </div>
      </div>

      <!-- UK Resident notice -->
      <div class="ip-cash-notice" *ngIf="foreignbuyer!=='1'" id="uk-currency-notice">
        <div class="ip-cash-notice__icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M5 9h14M5 15h14"></path></svg>
        </div>
        <div>
          <span class="ip-cash-notice__title">Home currency: GBP</span>
          <span class="ip-cash-notice__sub">As a UK Resident, returns are shown in pounds. FX appreciation doesn't apply.</span>
        </div>
      </div>

      <div class="ip-section-divider"><span class="ip-section-divider__label">Growth Assumptions</span></div>

      <!-- Investment Period -->
      <div class="ip-field">
        <label class="ip-field__label">Investment period</label>
        <div class="ip-chip-row">
          <button class="ip-chip" [class.is-active]="investedTenure=='3'"  (click)="investedTenure='3'"  type="button">3 yrs</button>
          <button class="ip-chip" [class.is-active]="investedTenure=='5'"  (click)="investedTenure='5'"  type="button">5 yrs</button>
          <button class="ip-chip" [class.is-active]="investedTenure=='7'"  (click)="investedTenure='7'"  type="button">7 yrs</button>
          <button class="ip-chip" [class.is-active]="investedTenure=='10'" (click)="investedTenure='10'" type="button">10 yrs</button>
        </div>
      </div>

      <!-- Gross Rental Yield -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="rentalYeild">Gross rental yield</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>{{ PropertyLondon == 1 ? 'London avg: 4.5%' : 'Manchester avg: 6.2%' }}</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="rentalYeild"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. {{ PropertyLondon == 1 ? '4.5' : '6.2' }}"
            [(ngModel)]="rentalYeild"
            (keyup)="rentalYeild=validation.appendPercent($event,rentalYeild)"
            (keypress)="validation.DesimalOnly($event,rentalYeild)">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

      <!-- Rental Escalation -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="rentalGrowthEscalation">Rental escalation p.a.</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>UK avg: 3–5%</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="rentalGrowthEscalation"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 3"
            [(ngModel)]="rentalGrowthEscalation"
            (keyup)="rentalGrowthEscalation=validation.appendPercent($event,rentalGrowthEscalation)"
            (keypress)="validation.DesimalOnly($event,rentalGrowthEscalation)">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

      <!-- Annual Capital Growth -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="capitalgrowth">Annual capital growth</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>10yr UK avg: 4.8%</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="capitalgrowth"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. {{ PropertyLondon == 1 ? '4.0' : '4.8' }}"
            [(ngModel)]="capitalgrowth"
            (keyup)="capitalgrowth=validation.appendPercent($event,capitalgrowth)"
            (keypress)="validation.DesimalOnly($event,capitalgrowth)">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

      <!-- FX Appreciation (foreign buyers only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1'" id="fx-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="fxgrowth">FX appreciation</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>GBP vs {{ homecurrencyText || 'home currency' }}</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="fxgrowth"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 4.0"
            [(ngModel)]="fxgrowth"
            (keyup)="fxgrowth=validation.appendPercent($event,fxgrowth)"
            (keypress)="validation.DesimalOnly($event,fxgrowth)">
          <span class="ip-input__suffix">% p.a.</span>
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/step2']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--primary" type="button" (click)="next()">
        Continue
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="foreignbuyer!=='1'">
          {{ foreignbuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">
        <!-- Property -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Property &amp; Financing</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Property value</span>
            <span class="ip-rs-row__val">£{{ calcData?.PropertyValue | number }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage=='1'">
            <span class="ip-rs-row__key">LTV · Deposit</span>
            <span class="ip-rs-row__val">{{ calcData?.loanAmount }}% LTV</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage=='0'">
            <span class="ip-rs-row__key">Financing</span>
            <span class="ip-rs-row__val">All-cash</span>
          </div>
        </div>

        <!-- Growth (current step) -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Currency &amp; Growth</span>
          </div>
          <div class="ip-rs-row" *ngIf="foreignbuyer==='1' && homecurrencyText">
            <span class="ip-rs-row__key">Home currency</span>
            <span class="ip-rs-row__val">{{ homecurrencyText }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="foreignbuyer!=='1'">
            <span class="ip-rs-row__key">Home currency</span>
            <span class="ip-rs-row__val">GBP</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Period</span>
            <span class="ip-rs-row__val">{{ investedTenure }} years</span>
          </div>
          <div class="ip-rs-row" *ngIf="rentalYeild">
            <span class="ip-rs-row__key">Rental yield</span>
            <span class="ip-rs-row__val">{{ rentalYeild }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="capitalgrowth">
            <span class="ip-rs-row__key">Capital growth</span>
            <span class="ip-rs-row__val">{{ capitalgrowth }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="foreignbuyer==='1' && fxgrowth">
            <span class="ip-rs-row__key">FX appreciation</span>
            <span class="ip-rs-row__val">{{ fxgrowth }}</span>
          </div>
        </div>

        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Costs &amp; Expenses</span>
          </div>
          <div class="ip-rs-row ip-rs-row--placeholder">
            <span class="ip-rs-row__key">SDLT, fees, charges</span>
            <span class="ip-rs-row__val">Step 4</span>
          </div>
        </div>
      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Indicative deposit</div>
        <div class="ip-rail-summary__outlay-value" *ngIf="calcData?.PropertyValue && calcData?.loanAmount">
          £{{ (calcData?.PropertyValue * (1 - calcData?.loanAmount / 100)) | number:'1.0-0' }}
        </div>
        <div class="ip-rail-summary__outlay-meta">Costs &amp; stamp duty added next</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
